export default [
    {
        path: '/subscription/list',
        component: () => import('../pages/news/subscription/index.vue'),
        meta: { title: '消息订阅' }
    },
    {
        path: '/dynamic/list',
        component: () => import('../pages/news/dynamic/index.vue'),
        meta: { title: '动态资讯' }
    },
]
